import { Navigate, Outlet, useNavigate } from 'react-router';
import { ArrowLeft, HardHat, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { ROLES } from '@sime/shared';

/**
 * Minimal layout for Lider mode — no sidebar, no desktop navigation.
 * Mobile-first, single-purpose: execute assigned OTs.
 */
export function LiderLayout() {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuthStore();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Only LIDER and ADMIN can access
  if (user.tipoUsuarioId !== ROLES.LIDER && user.tipoUsuarioId !== ROLES.ADMINISTRADOR) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen min-h-[100dvh] bg-sime-bg">
      {/* Header — minimal */}
      <header className="sticky top-0 z-40 bg-sime-surface border-b border-sime-border-subtle shadow-neu-sm">
        <div className="max-w-[900px] mx-auto px-4 py-3 flex items-center justify-between">
          <button
            type="button"
            onClick={() => { void navigate(-1); }}
            className="p-2 -ml-2 rounded-xl text-sime-text-secondary hover:text-sime-text-primary transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Volver"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>

          <div className="flex items-center gap-2">
            <HardHat className="h-5 w-5 text-sime-accent" />
            <span className="text-sm font-semibold text-sime-text-primary">
              Modo Lider
            </span>
          </div>

          <button
            type="button"
            onClick={() => { logout(); void navigate('/login'); }}
            className="p-2 -mr-2 rounded-xl text-sime-text-tertiary hover:text-sime-text-primary transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Cerrar sesion"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[900px] mx-auto px-4 py-4">
        <Outlet />
      </main>
    </div>
  );
}
